const Config = {
  VERSION: process.env.REAC_APP_VERSION,
  NAME: process.env.REACT_APP_NAME,
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  CARRIER_CONFIG_URL: process.env.REACT_APP_CARRIER_CONFIG_URL,
  USER_PREFERENCES_URL: process.env.REACT_APP_USER_PREFERENCES_URL,
  BASEPATH: process.env.REACT_APP_BASEPATH,
  BASEPATH_CARRIER_CONFIG: process.env.REACT_APP_BASEPATH_CARRIER_CONFIG,
  BASEPATH_USER_PREFERENCES_CONFIG: process.env.REACT_APP_BASEPATH_USER_PREFERENCES_CONFIG,
  OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER,
  ENV: process.env.REACT_APP_ENV,
}

export default Config
